<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="动态名称">
          <el-input placeholder="请输入动态名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>

          <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <!-- <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button> -->

        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加动态</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
      
            <el-table-column prop="name" label="动态名称"></el-table-column>
            <el-table-column prop="categorya" label="动态分类"></el-table-column>
            <!-- <el-table-column prop="intro" label="动态介绍"></el-table-column> -->
           <el-table-column prop="intro" label="动态介绍" width="200">
            <template slot-scope="scope">
              <span :title="stripHtmlTags(scope.row.intro)">
                {{ truncateText(stripHtmlTags(scope.row.intro), 50) }}
              </span>
            </template>
          </el-table-column>
            <el-table-column prop="nickName" label="用户昵称"></el-table-column>

            <!-- 审核状态列 -->
            <el-table-column prop="is_pass" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.is_pass == 0" type="warning" size="small">待审核</el-tag>
                <el-tag v-else-if="scope.row.is_pass == 1" type="success" size="small">已通过</el-tag>
                <el-tag v-else-if="scope.row.is_pass == 2" type="danger" size="small">已拒绝</el-tag>
                <el-tag v-else type="info" size="small">未知</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button 
                  @click="auditClick(scope.row)" 
                  type="text" 
                  size="small"
                  :disabled="scope.row.is_pass !== 0"
                  :class="{ 'disabled-btn': scope.row.is_pass !== 0 }">
                  审核
                </el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :dynamics_id="dynamics_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <!-- <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import> -->
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
      title="审核动态"
      :visible.sync="auditDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAuditDialog"
    >
      <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="100px">
        <el-form-item label="动态名称">
          <span>{{ auditForm.name }}</span>
        </el-form-item>
        <el-form-item label="审核结果" prop="is_pass">
          <el-radio-group v-model="auditForm.is_pass">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝原因" prop="reason" v-if="auditForm.is_pass === 2">
          <el-input
            type="textarea"
            v-model="auditForm.reason"
            placeholder="请输入拒绝原因"
            :rows="3"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="auditLoading">确 定</el-button>
      </span>
    </el-dialog>
  
  </div>
</template>

<script>
  import DynamicsApi from '@/api/dynamics.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  // import Import from './part/import.vue';

  export default {
    components: {
      Add,
      Edit,
      // Import,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        dynamics_id:"",
        dialogVisible:false,
        open_import:false,
        /*选中的*/
        selection: [],
        selectedRows: [], // 选中的行数据

        // 审核弹窗相关
        auditDialogVisible: false,
        auditLoading: false,
        auditForm: {
          dynamics_id: '',
          name: '',
          is_pass: 1,
          reason: ''
        },
        auditRules: {
          is_pass: [
            { required: true, message: '请选择审核结果', trigger: 'change' }
          ],
          reason: [
            { required: true, message: '请输入拒绝原因', trigger: 'blur' }
          ]
        }
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//动态标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
      /* 多选框选择变化 */
      handleSelectionChange(selection) {
        this.selectedRows = selection;
      },
 // 去除HTML标签
  stripHtmlTags(html) {
    if (!html) return '-';
    // 使用正则去除所有HTML标签
    return html.replace(/<[^>]+>/g, '');
  },
  
  // 截取文本
  truncateText(text, maxLength = 50) {
    if (!text || text === '-') return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  },
      /* 清空选择 */
      clearSelection() {
        if (this.multipleTable) {
          this.multipleTable.clearSelection();
        }
        this.selectedRows = [];
      },
      closeImport(e) {
        this.open_import = false;
        if (e.type === "success") {
          this.getTableList(); // 导入成功后刷新列表
        }
      },
      importClick() {
        this.open_import = true;
      },
      exportData() {
        // 构建导出参数
        let exportParams = {
          name: this.formInline.name,
        };

        // 如果有选中的数据，添加选中的ID；否则导出全部（不传selected_ids参数）
        if (this.selectedRows.length > 0) {
          const selectedIds = this.selectedRows.map(row => row.dz_spec_id);
          exportParams.selected_ids = selectedIds.join(',');
        }

        // 使用页面跳转方式导出，避免blob处理
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let queryString = Object.keys(exportParams)
            .filter(key => exportParams[key] !== '')
            .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
            .join('&');

        window.location.href = baseUrl + '/index.php/shop/plus.dynamics.Index/export?' + queryString;
      },
      /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        DynamicsApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.dynamics_id = row.dynamics_id;
        this.open_edit = true
      },

        /*审核点击*/
    auditClick(row) {
      // 只允许审核待审核状态的动态
      if (row.is_pass !== 0) {
        this.$message.warning('该动态已经审核过了，无法再次审核');
        return;
      }
      this.auditForm = {
        dynamics_id: row.dynamics_id,
        name: row.name,
        is_pass: 1,  // 默认选中通过
        reason: ''
      };
      this.auditDialogVisible = true;
    },

      /*关闭审核弹窗*/
      closeAuditDialog() {
        this.auditDialogVisible = false;
        this.auditForm = {
          dynamics_id: '',
          name: '',
          is_pass: 1,
          reason: ''
        };
        this.$nextTick(() => {
          if (this.$refs.auditForm) {
            this.$refs.auditForm.resetFields();
          }
        });
      },

      /*提交审核*/
      submitAudit() {
        let self = this;
        this.$refs.auditForm.validate(valid => {
          if (valid) {
            self.auditLoading = true;
            let submitData = {
              dynamics_id: self.auditForm.dynamics_id,
              is_pass: self.auditForm.is_pass,
              reason: self.auditForm.reason || ''
            };
            DynamicsApi.audit(submitData, true)
              .then(data => {
                self.auditLoading = false;
                if (data.code == 1) {
                  self.$message({
                    message: data.msg || '审核成功',
                    type: 'success'
                  });
                  self.auditDialogVisible = false;
                  self.getTableList(); // 刷新列表
                } else {
                  self.$message.error(data.msg || '审核失败');
                }
              })
              .catch(error => {
                self.auditLoading = false;
                self.$message.error('审核失败');
              });
          }
        });
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DynamicsApi.del(
              {
                dynamics_id: row.dynamics_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style scoped>
.disabled-btn {
  color: #c0c4cc !important;
  cursor: not-allowed !important;
}
.disabled-btn:hover {
  color: #c0c4cc !important;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/dynamics/index/index.vue